var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccumulation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M54.1666 26.0244V23.8889C54.1666 22.4246 52.9667 21.2246 51.5023 21.2246H22.8257C21.3613 21.2246 20.1614 22.4246 20.1614 23.8889V26.0244V33.4275V42.9253C20.1614 44.3897 21.3613 45.5896 22.8257 45.5896H51.5023C52.9667 45.5896 54.1666 44.3897 54.1666 42.9253V26.0244Z",
    fill: "#EA0404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0786 15.3066V13.1711C50.0786 11.7068 48.8786 10.5068 47.4143 10.5068H5.49754C4.0332 10.5068 2.83325 11.7068 2.83325 13.1711V15.3066V22.7097V39.3462C2.83325 40.8106 4.0332 42.0105 5.49754 42.0105H47.4143C48.8786 42.0105 50.0786 40.8106 50.0786 39.3462V15.3066Z",
    stroke: "#EA0404",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0786 17.3408H2.83325V25.476H50.0786V17.3408Z",
    fill: "#EA0404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccumulation);
export default __webpack_public_path__ + "static/media/Accumulation.9975d6c753896a6dcbeaea82d43193a4.svg";
export { ForwardRef as ReactComponent };